<template lang="pug">
  .vendor-upload-proposal(v-loading="loading")
    brief
    title-bar {{ $t('方案上传') }}
    div(v-if="isView" style="margin-left: 20px")
      upload-multiple-file(
        style="margin: 30px 0"
        :text="$t('方案')"
        :fileName="proposalData.file_name"
        :downloadUrl="proposalData.download_url"
        :files="proposalData.file_name_list"
      )

    div(v-else style="margin-left: 20px")
      upload-multiple-file(
        axiosUrl="/management/subfinal/saveFile"
        :params="uploadParams"
        :text="$t('方案')"
        @uploading="loading = true"
        @success="uploadSuccess"
        style="margin: 30px 0"
      )
      el-row
        el-col(:span="20" :offset="4")
          footer-button(
            :confirmButton="$t('提交')"
            @confirm="onConfirm"
            @cancel="cancel"
          )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import UploadMultipleFile from '@/components/UploadMultipleFile'
import UploadProposalAndQuotation from './UploadProposalAndQuotation'
import { format4backend } from '@/umcc/util'
import axios from 'axios'
import FooterButton from '@/components/FooterButton'
import Brief from './Brief'

export default {
  components: {
    TitleBar,
    UploadMultipleFile,
    UploadProposalAndQuotation,
    FooterButton,
    Brief
  },
  data () {
    return {
      briefName: '',
      briefPath: '',
      briefFiles: [],
      briefRemark: '',
      proposalPath: '',
      proposalData: {},
      loading: false
    }
  },
  computed: {
    deliverVendorId () {
      return this.$store.state.campaign.deliverVendorId
    },
    taskName () {
      return this.$store.state.campaign.taskName
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    uploadParams () {
      return {
        campaign_id: this.campaignId,
        file_type: 3
      }
    }
  },
  mounted () {
    if (this.isView) {
      this.fetchProposalData()
    }
  },
  methods: {
    fetchProposalData () {
      this.loading = true
      axios.get('/common/getBusinessLog', {
        params: {
          servlet_path: this.$route.path,
          business_key: this.deliverVendorId
        }
      })
        .then(res => {
          this.proposalData = res.campaign_deliver_vendor
          this.loading = false
        })
    },
    uploadSuccess (res) {
      this.proposalPath = res.file_path
      this.loading = false
    },
    onConfirm () {
      if (this.proposalPath === '') {
        this.$message.error(this.$t('请上传方案'))
        return
      }
      const params = {
        campaign_deliver_vendor: {
          campaign_deliver_vendor_id: this.$store.state.campaign.deliverVendorId,
          campaign_id: this.$store.state.campaign.id,
          plan_path: this.proposalPath
        },
        servlet_path: this.$route.path,
        task_name: this.taskName,
        task_id: this.$store.state.campaign.taskId
      }
      this.loading = true
      axios
        .post('/management/subfinal/saveVendorPlan', format4backend(params))
        .then(() => {
          this.loading = false
          this.$message.success(this.$t('提交成功'))
          this.$router.push('/vendor-campaign/process')
        })
    },
    cancel () {
      this.$router.push('/vendor-campaign/process')
    }
  }
}
</script>
